<template>
  <div class="piece" :style="posStyle">
    <img class="avatar" :src="team.iconUrl" :style="{ width: size + 'px', height: size + 'px' }" alt="" />
    <span class="badge" :class="{ my: myTeam }">{{ team.name }}</span>
  </div>
</template>

<script>
export default {
  name: "TeamPiece",
  props: {
    team: { type: Object, required: true },
    x: { type: Number, required: true },          // design px
    y: { type: Number, required: true },          // design px
    design: { type: Object, required: true },     // { w, h }
    size: { type: Number, default: 48 },
    myTeam: { type: Boolean, default: false }
  },
  computed: {
    posStyle() {
      const left = (this.x / this.design.w) * 100
      const top  = (this.y / this.design.h) * 100
      return { left: left + "%", top: top + "%" }
    }
  }
}
</script>

<style scoped>
.piece {
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 4;
  pointer-events: none;
  /* Smooth hop on position changes */
  transition: left 0.85s ease-in-out, top 0.85s ease-in-out;
  will-change: left, top;
}
.avatar { border-radius: 50%; display: block; }
.badge {
  position: absolute;
  left: calc(100% + 6px);
  top: -8px;
  background: rgba(0,0,0,.6);
  color: #fff;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
}
.badge.my {
  background: rgba(240, 224, 125, .9);
  color: #000;
  font-weight: 600;
}
</style>
